import React from 'react';
import '../../styles/conduct-discipline/main.css';

const Main = () => {
    return (
        <div id='conductDiscipline'>
            <div className="conduct-discipline-main">
                <div className="container main-box pb-5">
                    <div className="box">
                        <h1 className="my-heading">Conduct &amp; Discipline</h1>
                        <div className="details" id="founder">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <p className="text-justify">
                                    <strong>1.&nbsp;</strong> If a student is found guilty of grave
                                    misconduct of breach or discipline or ragging or holding of
                                    introduction nights or such other practices adopted to harass other
                                    students within or outside the premises of the University or Hostel,
                                    the Head of the Department or Proctor may, according to the nature
                                    and gravity of the offence, punish him/her as per the provisions
                                    laid down in Act and Statutes.
                                </p>
                                <p className="text-justify">
                                    <strong>2.&nbsp;</strong> The Proctor shall have the power to
                                    suspend a student temporarily from the University pending enquiry
                                    into his/her conduct in connection with an alleged misconduct.
                                    However, before inflicting a punishment on the student an
                                    opportunity of personal hearing of explanations of his/her conduct
                                    in writing shall be given to him/her.
                                </p>
                                <p className="text-justify">
                                    <strong>3.&nbsp;</strong> If the Vice-Chancellor feels satisfied
                                    that a student of the University has been guilty of grave
                                    misconduct, breach of discipline causing harassment to an authority,
                                    teacher, student or employee of the University or of causing
                                    destruction to University property, he may according to the nature
                                    and gravity of the offence, punish him as per provisions laid down
                                    in Act and Statutes.
                                </p>
                                <h4 className="line-bottom mt-10 mb-10 pt-5">Proctorial Board</h4>
                                <hr />
                                <p className="text-justify">
                                    The proctorial board consisting of a Proctor and Assistant Proctors
                                    assist the Vice-Chancellor in the exercise of his disciplinary
                                    authority in respect of students of the university and also exercise
                                    such powers and perform such duties in respect of discipline as may
                                    be assigned to the proctorial board by the Vice-Chancellor. The
                                    proctor issues the Identity Cards to the students of the university
                                    campus on the advise of the concerned departments. Application forms
                                    for this purpose shall be available in the office of the concerned
                                    teaching departments and the students need to complete all
                                    formalities and obtain the Identity Cards within 15 days of their
                                    admission/readmission to the university.
                                </p>
                                <h4 className="line-bottom mt-10 mb-10 pt-5">
                                    The University Proctor
                                </h4>
                                <hr />
                                <p className="text-justify">
                                    There is a University Proctor who shall assist the Vice-Chancellor
                                    in the exercise of his disciplinary authority in respect of students
                                    of the University and shall also exercise such powers and perform
                                    such duties in respect of discipline as may be assigned to him by
                                    the Vice-Chancellor. The Proctor shall be assisted by Assistant
                                    Proctors.
                                </p>
                                <h4 className="line-bottom mt-30 mb-10">Issue of Identity Card</h4>
                                <hr />
                                <p className="text-justify">
                                    Identity card should be obtained by every student of the University
                                    from the office of the Proctor after the completion of admission.
                                    Application forms for the purpose shall be available in the office
                                    of the concerned teaching Department. The students should fill in
                                    the form, get it forwarded by the Head of the Department and submit
                                    the same to the office of the Proctor with one extra copy of his/her
                                    passport size photograph (facing camera) within 15 days of his/her
                                    admission.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;